module.exports = __webpack_public_path__ + "images/logo/tosho_prime_logo_7beb16abe4aca6074abd76b7b0a03bf0.webp";